import { sortBy } from 'lodash';
import moment from 'moment';
import { useMemo } from 'react';
import { useEventQuestion } from './useEventQuestion';

export function useQuestionAnswers(eventId, questionId) {
    const question = useEventQuestion(eventId, questionId);
    return useMemo(() => sortBy(question?.answers?.data || [], (answer) => -1 * moment(answer.date_created).valueOf()), [question]);
}
